import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useWizard } from 'react-use-wizard';

import { Button, ButtonVariant } from '@/components/form/button';
import { useSettings } from '@/features/user-settings/hooks/use-settings';
import { ChamberDepth, SquareSize } from '@/features/user-settings/types';
import {
  getChamberDepthOptions,
  getSquareSizeOptions,
} from '@/features/user-settings/utils/dropdown-option-mapper';

import { SettingDropdownItem } from '../../settings-dropdown-item';

export const CountingChamberStep = () => {
  const { t } = useTranslation();
  const { nextStep, previousStep } = useWizard();
  const { settings, setSettings } = useSettings();

  const chamberOptions = useMemo(() => getChamberDepthOptions(), []);
  const squareSizeOptions = useMemo(() => getSquareSizeOptions(), []);

  const { control, handleSubmit } = useForm();

  const onSubmit = handleSubmit((data) => {
    setSettings({ ...settings, ...data });
    nextStep();
  });

  return (
    <div>
      <div className="flex flex-col gap-4 py-10 md:py-16 md:px-20 text-lg">
        <p className="text-black-dark text-lg">{t('calibration.step2.text1')}</p>
        <div className="flex flex-col gap-3">
          <SettingDropdownItem
            control={control}
            labelWidth="w-44"
            parser={parseFloat}
            dropdownWidth="w-40"
            name="chamberHeight"
            options={chamberOptions}
            defaultValue={ChamberDepth.O_2}
            label="userSettings.chamberHeight"
          />
          <SettingDropdownItem
            control={control}
            name="squareSize"
            labelWidth="w-44"
            parser={parseFloat}
            dropdownWidth="w-40"
            options={squareSizeOptions}
            label="userSettings.squareSize"
            defaultValue={SquareSize.O_0025}
          />
        </div>
      </div>
      <div className="flex justify-between">
        <Button variant={ButtonVariant.Secondary} onClick={previousStep}>
          {t('common.back')}
        </Button>
        <Button onClick={onSubmit}>{t('common.next')}</Button>
      </div>
    </div>
  );
};
